import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CustomerFilterViewMoel } from "../model/CustomerFilterViewModel";

interface CustomerSearchResultState {
    results: CustomerFilterViewMoel[];
    // distinguishes "searched with no matches" from "never searched / lost on refresh"
    isLoaded: boolean;
}

const initialState: CustomerSearchResultState = {
    results: [],
    isLoaded: false
}

const customerSearchResultSlice = createSlice({
    name: "customerSearchResult",
    initialState,
    reducers: {
        setCustomerSearchResults(state, action: PayloadAction<CustomerFilterViewMoel[]>) {
            state.results = action.payload;
            state.isLoaded = true;
        },
        clearCustomerSearchResults(state) {
            state.results = [];
            state.isLoaded = false;
        }
    }
})

export const { setCustomerSearchResults, clearCustomerSearchResults } = customerSearchResultSlice.actions;
export default customerSearchResultSlice.reducer;
